import React from 'react';
import { Outlet } from 'react-router-dom';

const SelectClientLayout: React.FC = () => {
  return <Outlet />;
};

export default SelectClientLayout;
